export default "__VITE_ASSET__CcccHxzR__"